/*
 * Bravo · Sincroniza el selector de cantidad con Kaching Bundles.
 *
 * El problema: Kaching gestiona las unidades de sus packs por su cuenta. Si el
 * cliente elige un pack de 3 y ademas deja el selector en 3, se arriesga a
 * pedir 3 packs de 3. Asi que mientras haya un pack elegido, manda el pack: el
 * selector muestra sus unidades y se bloquea.
 *
 * Kaching avisa de los cambios con eventos propios sobre <kaching-bundles-block>:
 *   - variants-changed  : detail.variantIdQuantities = [{variantId, quantity}]
 *   - deal-bar-selected : detail = id de la barra elegida
 * (documentado en support.kachingappz.com, articulo 8609400)
 *
 * Si la tienda no tiene Kaching, o el producto no tiene oferta, el selector
 * funciona como uno normal y este fichero no hace nada.
 */
(function () {
  'use strict';

  var ESPERA_MAXIMA = 8000; /* si Kaching no aparece, se deja de esperar */

  function selectores() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-bravo-quantity]'));
  }

  function bloquear(caja, unidades) {
    var input = caja.querySelector('[data-quantity-field]');
    if (!input) return;

    caja.dataset.locked = 'true';
    input.value = unidades;
    input.readOnly = true;
    /* el evento deja que el tema actualice precios y estado del boton */
    input.dispatchEvent(new Event('change', {bubbles: true}));

    caja.querySelectorAll('[data-quantity-button]').forEach(function (b) {
      b.disabled = true;
    });
  }

  function desbloquear(caja) {
    var input = caja.querySelector('[data-quantity-field]');
    if (!input) return;

    if (caja.dataset.locked !== 'true') return;
    delete caja.dataset.locked;
    input.readOnly = false;
    input.value = input.getAttribute('min') || 1;
    input.dispatchEvent(new Event('change', {bubbles: true}));

    caja.querySelectorAll('[data-quantity-button]').forEach(function (b) {
      b.disabled = false;
    });
  }

  /* Suma las unidades de todas las variantes del pack elegido. */
  function unidadesDe(detalle) {
    if (!detalle) return 0;
    var lista = detalle.variantIdQuantities;
    if (!Array.isArray(lista)) return 0;
    return lista.reduce(function (total, v) {
      return total + (Number(v && v.quantity) || 0);
    }, 0);
  }

  function conectar(bloque) {
    var cajas = selectores();
    if (!cajas.length) return;

    function alCambiar(e) {
      var unidades = unidadesDe(e.detail);
      cajas.forEach(function (caja) {
        if (unidades > 1) bloquear(caja, unidades);
        else desbloquear(caja);
      });
    }

    bloque.addEventListener('variants-changed', alCambiar);

    /* Al elegir la barra de una sola unidad, Kaching no siempre manda
       variants-changed: se devuelve el control al selector. */
    bloque.addEventListener('deal-bar-selected', function () {
      setTimeout(function () {
        var activa = bloque.querySelector('[data-deal-bar-id][aria-checked="true"], .kaching-bundles__bar--selected');
        var q = activa && Number(activa.getAttribute('data-quantity'));
        if (!q || q <= 1) cajas.forEach(desbloquear);
      }, 150);
    });
  }

  function arrancar() {
    if (!selectores().length) return;

    var bloque = document.querySelector('kaching-bundles-block');
    if (bloque) return conectar(bloque);

    /* Kaching se pinta despues: se espera a que aparezca, sin eternizarse. */
    if (!document.querySelector('script[src*="kaching-bundles"]')) return;

    var desde = Date.now();
    var obs = new MutationObserver(function () {
      var b = document.querySelector('kaching-bundles-block');
      if (b) {
        obs.disconnect();
        conectar(b);
      } else if (Date.now() - desde > ESPERA_MAXIMA) {
        obs.disconnect();
      }
    });
    obs.observe(document.body, {childList: true, subtree: true});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
